import React, {useState, useEffect, useRef, useCallback} from 'react'
import _ from '/home/ps/root'
import Search from '../search'
import './index.css'
// import {connect} from 'react-redux'
import { Ref, cache, session } from '../../../global'
import { go } from '../../../io'
// import {
//   masterPropType,
//   masterStateToProp,
//   masterDispatchToProp,
// } from '../../../type'
// https://css-tricks.com/solved-with-css-dropdown-menus/
// https://codepen.io/una/pen/pVvXmK
const ID = 'header'
// const Logo = document.getElementById(`#${_.LOGO}`)
const Header = prop => {
  const {uid, owner, vendorname, username, online, u, route, lang, master, login, cookie} = prop.master//[_.INIT][_.MASTER][_.RESPONSE]
  const { park } = prop
  // const name = park[_.LOGIN]?.[_.USER]?.[_.DEF]?.[cookie[_.ID]] && park[_.LOGIN][_.USER][_.DEF][uid][_.NAME] || cache(uid) && cache(uid)[_.NAME]
  const cname = session(uid)
  const name = park.login?.user?.default?.[uid]?.name || cname?.name || cookie.name || 'fix name'
  // if (name && user[_.ID]) debugger
  // if (name) debugger
  if (!master) return null
  const [state, _setState] = useState({visibility: 'hidden', display: 'none', opacity: 1, id: 'login'})
  const {visibility, display, opacity, id} = state
  const setState = s => _setState(_s => ({..._s, ...s}))
  useEffect(() => {
    if (_.USER_.includes(id) && prop.new[uid])  {
      const el = document.getElementById(`${ uid } login ${ prop.master.verb } ${ prop.new[uid].login } username`)
      if (el) {debugger
        el.focus()
        el.select()
      }
    }
  })
  const store = u=='store'
  const edit = u=='edit'
  const style = {
     // visibility,
     // display,
     // opacity,
  }
  // const pRef = useRef(prop)
  // useEffect(() => {
  //   pRef.current = prop
  //   console.log({pRef})
  // }, [prop])
  const onHeader = (e, id) => {
    console.log(`Header.onHeader ${id}`)
    e.stopPropagation()
    e.preventDefault()
    // console.log(pRef.current, prop.slide, IO)
    if (Ref.slide?.slide) Ref.slide.slide('logo', 'hide')
    // if (!pRef.current.slide) debugger
    // pRef.current.slide('logo')
    switch (id) {
      // case _.SEARCH: debugger
      // case _.LANG: debugger
      // case _.APP: debugger
      // case _.LOGIN: setState({visibility: 'visible', display: 'block'})
    }
  }
  const onClick = (e, id) => {
    console.log(`Header.onClick ${id}`)
    e.stopPropagation()
    e.preventDefault()
    const route = []
    if (Ref.slide.slide) Ref.slide.slide('logo', 'hide')
    switch (id) {
      case 'forget':
      case 'login':
      // case 'register': uris.push(lang, username, id); break
      case 'register': route.push(username, id); break
      case 'profile':
      // case 'logout': uris.push(lang, 'master', id); break
      case 'logout': route.push('master', id); break
      // case _.LOGOUT: uris.push(lang, user[_.TITLE], id); break
      case 'about':
      case 'help':
      // case 'feed': uris.push(lang, 'q', id); break
      case 'feed': route.push('q', id); break
      // case 'q': uris.push(lang, id);break
      case 'q': route.push(id);break
      // case 'store': uris.push(lang, username);break
      case 'store': route.push(username);break
      // case 'edit': uris.push(lang, username, 'edit');break
      case 'edit': route.push(username, 'edit');break
      // case 'reset': uris.push(lang, username, id);break
      case 'reset': route.push(username, id);break
      default: debugger
    }
    go(prop.history.push, route)
    setState({id})
    // const focus = document.getElementById(_.HEADER)
    // focus.focus({focusVisible: true})
    // go(prop.history.push, `/${uris.join('/')}`)
    // let ok = true
    // if (online) {
    //   ok = window.confirm(`${master[_.GO][_.I]} ${master[_.OFFLINE][_.I]}`)
    // }
    // if (uris.length && ok) {
    //   prop.history.push(`/${uris.join('/')}`)
    //   const focus = document.getElementById(_.HEADER)
    //   focus.focus({focusVisible: true})
    // }
  }
  const currLang = master.lang[lang]
  const langs = Object.keys(master.lang).reduce((acc, l) => {
    if (l!=lang) acc.push(<li key={l} onClick={e=>onClick(e, l)}><a href="#">{master.lang[l]}</a></li>)
    return acc
  }, [])
  return (
    <div id={ID}>
      <nav role="navigation">
        <ul>
          {<li onClick={e=>onHeader(e, 'search', prop)}><a href="#">Search</a></li>}
          {/*<li className={_.SEARCH}>
            <input/>
            <button>Search</button>
          </li>*/}
          <li onClick={e=>onHeader(e, 'login', prop)}>
            {/*<a aria-haspopup="true">{login ? decodeURI(user[_.NAME]) : master[_.LOGIN][_.I]}</a>*/}
            <a aria-haspopup="true">{login ? name : master.login.i}</a>
            {login ?
              (
                <ul className="dropdown" aria-label="submenu" style={style}>
                {
                  !(store && owner) &&
                  <li><a onClick={e=>onClick(e, 'store')}   >{master.store.i}   </a></li>
                }
                {
                  !(edit && owner) &&
                  <li><a onClick={e=>onClick(e, 'edit')}   >{master.edit.i} {master.store.i}</a></li>
                }
                {
                  u!='profile' &&
                  <li><a onClick={e=>onClick(e, 'profile')}>{master.profile.i}</a></li>
                }
                {
                  !(store && vendorname=='q') &&
                  <li><a onClick={e=>onClick(e, 'q')}        >{master.q.i}        </a></li>
                }
                {
                  u!='logout' &&
                  <li><a onClick={e=>onClick(e, 'logout')} >{master.logout.i} </a></li>
                }
                </ul>
            ) : (
              <ul className="dropdown" aria-label="submenu">
                {u!='login' &&
                  <li><a onClick={e=>onClick(e, 'login')}   >{master.login.i}   </a></li>
                }
                {u!='register' &&
                  <li><a onClick={e=>onClick(e, 'register')}>{master.register.i}</a></li>
                }
                {u!='forget' &&
                  <li><a onClick={e=>onClick(e, 'forget')}   >{master.forget.i}   </a></li>
                }
              </ul>
            )}
          </li>
          <li onClick={e=>onHeader(e, 'lang', prop)}>
            <a href="#" aria-haspopup="true">{currLang}</a>
            <ul className="dropdown" aria-label="submenu">
              {langs}
            </ul>
          </li>
          <li onClick={e=>onHeader(e, 'app', prop)}>
            <a href="#">App</a>
            <ul className="dropdown" aria-label="submenu">
              {u!='about' &&
                <li><a onClick={e=>onClick(e, 'about')}>{master.about.i}</a></li>
              }
              {u!='feed' &&
                <li><a onClick={e=>onClick(e, 'feed')}>{master.feed.i}</a></li>
              }
              {u!='help' &&
                <li><a onClick={e=>onClick(e, 'help')}>{master.help.i}</a></li>
              }
              {u!='reset' &&
                <li><a onClick={e=>onClick(e, 'reset')}>{master.reset.i}</a></li>
              }
            </ul>
          </li>
        </ul>
      </nav>
    </div>
  )
}
Header.ID = ID
export default Header
